import Vue from 'vue'
import Vuex from 'vuex'
import DGantt from './modules/DGantt'
import Base from './modules/Base'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        dgantt: DGantt,
        base: Base,
    },
    strict: debug,
    plugins: []
})